import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mentor');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-mentor',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.mentor/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMentorComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public loaded: boolean = false;
    public is_mentor: boolean = false;
    public user_id: string = '';
    public assignments: any[] = [];
    public sessions: any[] = [];
    public reports: any[] = [];
    public feedbacks: any[] = [];
    public documentContexts: any[] = [];

    public menu: string = 'overview';
    public menus = [
        { key: 'overview', label: '내 멘토링' },
        { key: 'sessions', label: '회차/일정' },
        { key: 'diagnosis', label: '기업진단' },
        { key: 'records', label: '활동 기록' },
        { key: 'documents', label: '멘토 제출서류' },
        { key: 'reports', label: '보고서' },
    ];

    // Report editor
    public showReportEditor: boolean = false;
    public reportTemplate: any = null;
    public reportForm: any = this._emptyReport();
    public showFeedbackEditor: boolean = false;
    public feedbackForm: any = this._emptyFeedback();
    public showDocumentEditor: boolean = false;
    public documentContext: any = null;
    public documentRequest: any = null;
    public documentForm: any = { form_data: {} };
    public showScheduleEditor: boolean = false;
    public scheduleAssignment: any = null;
    public scheduleForm: any = this._emptyScheduleForm();

    private _emptyReport() {
        return { program_id: '', module_id: '', application_id: '', title: '', form_data: {}, content: '', target_audience: 'internal' };
    }

    private _emptyFeedback() {
        return {
            id: '',
            assignment_id: '',
            program_id: '',
            module_id: '',
            application_id: '',
            feedback_type: 'mentor',
            title: '',
            score: null,
            content: '',
            is_visible_to_company: true,
        };
    }

    private _emptyScheduleForm() {
        return { start_at: '', end_at: '', duration_min: 60, location: '', online_url: '', note: '' };
    }

    // ===== 기업진단 =====
    public diagTargets: any[] = [];
    public diagTarget: any = null;        // 선택된 (application, module) 페어
    public diagSummary: any = null;
    public diagTemplate: any = { scale: 7, categories: [] };
    public diagForm: any = { items: [], overall_comment: '' };
    public hexSize: number = 200;
    public hexCenter: number = 220;

    public async ngOnInit() {
        await this.service.init();
        this.menu = (WizRoute.segment && WizRoute.segment.menu) || 'overview';
        await this._loadMe();
        if (!this.is_mentor) {
            this.loaded = true;
            await this.service.render();
            return;
        }
        await this._loadByMenu();
        this.loaded = true;
        await this.service.render();
    }

    public async go(menu: string) {
        this.menu = menu;
        this.service.href(`/mentor/${menu}`);
        this.diagTarget = null;
        await this._loadByMenu();
        await this.service.render();
    }

    private async _loadMe() {
        const res = await wiz.call('me', {});
        if (res.code === 200) {
            this.is_mentor = !!res.data?.is_mentor;
            this.user_id = res.data?.user_id;
            this.assignments = res.data?.assignments || [];
        }
    }

    private async _loadByMenu() {
        if (this.menu === 'sessions') {
            const res = await wiz.call('list_my_sessions', {});
            this.sessions = res.data?.rows || [];
        } else if (this.menu === 'reports') {
            const res = await wiz.call('list_my_reports', {});
            this.reports = res.data?.rows || [];
        } else if (this.menu === 'records') {
            const res = await wiz.call('list_my_feedbacks', {});
            this.feedbacks = res.data?.rows || [];
        } else if (this.menu === 'documents') {
            const res = await wiz.call('list_my_documents', {});
            this.documentContexts = res.data?.rows || [];
        } else if (this.menu === 'diagnosis') {
            const res = await wiz.call('diagnosis_targets', {});
            this.diagTargets = res.data?.rows || [];
        }
    }

    public openDiagTarget(t: any) {
        this.diagTarget = t;
        this.diagSummary = t.summary;
        this.diagTemplate = (t.summary && t.summary.template) || { scale: 7, categories: [] };
        this._buildDiagForm();
        this.service.render();
    }

    public backToDiagList() {
        this.diagTarget = null;
        this.service.render();
    }

    private _buildDiagForm() {
        const items: any[] = [];
        const stage = this.diagStage();
        for (const cat of (this.diagTemplate.categories || [])) {
            for (const it of (cat.items || [])) {
                const q = this.diagQuestionText(it, stage);
                items.push({
                    cat: cat.key,
                    code: it.code || '',
                    label: it.label || q,
                    q,
                    score: 0,
                    comment: ''
                });
            }
        }
        this.diagForm = { items, overall_comment: '' };
    }

    public diagStage(): string {
        return this.diagTarget?.stage || 'seed';
    }

    public diagQuestionText(it: any, stage: string = ''): string {
        const s = stage || this.diagStage();
        return (it?.questions && it.questions[s]) || it?.q || it?.label || '';
    }

    public applicationAttachments(): any[] {
        const app = this.diagTarget?.application || {};
        const attachments = app.attachments;
        return Array.isArray(attachments) ? attachments : [];
    }

    public proposalFileUrl(): string {
        const url = this.diagTarget?.application?.proposal_file || '';
        return typeof url === 'string' ? url : '';
    }

    private _attachmentBlob(a: any): string {
        return [
            a?.key, a?.field_id, a?.field_label, a?.label,
            a?.original_name, a?.name, a?.stored_name, a?.path
        ].filter((x: any) => !!x).join(' ').toLowerCase();
    }

    public reviewAttachments(kind: 'plan' | 'ir' | 'all'): any[] {
        const all = this.applicationAttachments();
        if (kind === 'all') return all;
        const planTokens = ['plan', 'proposal', 'business', '사업계획', '사업 계획', '계획서'];
        const irTokens = ['ir', 'deck', 'pitch', '피칭', '투자유치'];
        const tokens = kind === 'plan' ? planTokens : irTokens;
        return all.filter((a: any) => {
            const blob = this._attachmentBlob(a);
            return tokens.some((t: string) => blob.indexOf(t) >= 0);
        });
    }

    public attachmentDownloadUrl(a: any): string {
        if (!a || !this.diagTarget?.application_id) return '#';
        const appId = this.diagTarget.application_id;
        if (a.path) {
            const params = new URLSearchParams({ application_id: appId, path: a.path });
            return `/wiz/api/portal.lpsysadmin.support.application.item/download?${params.toString()}`;
        }
        if (a.stored_name) {
            const params = new URLSearchParams({
                application_id: appId,
                stored_name: a.stored_name,
                original_name: a.original_name || a.name || a.stored_name,
            });
            return `/wiz/api/portal.lpsysadmin.support.program.item/download_application_file?${params.toString()}`;
        }
        return a.url || '#';
    }

    public attachmentName(a: any): string {
        return a?.original_name || a?.name || a?.stored_name || a?.path || '파일';
    }

    public attachmentBadge(a: any): string {
        return a?.field_label || a?.field_id || a?.key || '';
    }

    public formatBytes(n: any): string {
        const v = Number(n) || 0;
        if (!v) return '';
        if (v < 1024) return `${v} B`;
        if (v < 1024 * 1024) return `${(v / 1024).toFixed(1)} KB`;
        return `${(v / 1024 / 1024).toFixed(2)} MB`;
    }

    public diagScaleArray(): number[] {
        const n = Number(this.diagTemplate?.scale) || 7;
        return Array.from({ length: n }, (_, i) => i + 1);
    }

    public setDiagScore(idx: number, s: number) {
        this.diagForm.items[idx].score = s;
    }

    public async submitDiagnosis() {
        if (!this.diagTarget) return;
        const payload = {
            program_id: this.diagTarget.program_id,
            module_id: this.diagTarget.module_id,
            application_id: this.diagTarget.application_id,
            stage: this.diagStage(),
            items: this.diagForm.items,
            overall_comment: this.diagForm.overall_comment,
            status: 'submitted',
        };
        const res = await wiz.call('submit_expert_diagnosis', { data: JSON.stringify(payload) });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '제출 실패', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '완료', message: '전문가 진단이 제출되었습니다', action: '확인' });
        // 재조회
        const r = await wiz.call('diagnosis_summary', { application_id: this.diagTarget.application_id, module_id: this.diagTarget.module_id });
        if (r.code === 200) {
            this.diagSummary = r.data.data;
            this._buildDiagForm();
        }
        await this._loadByMenu();
        await this.service.render();
    }

    public hasScores(t: string): boolean {
        const s = this.diagSummary?.scores?.[t];
        return !!(s && Object.keys(s).length > 0);
    }

    public hexPoints(scoreMap: any): string {
        const cats = this.diagTemplate.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        const max = this.diagTemplate.scale || 7;
        const pts: string[] = [];
        const n = cats.length || 6;
        for (let i = 0; i < n; i++) {
            const key = cats[i]?.key || '';
            const v = Number((scoreMap || {})[key] || 0);
            const ratio = Math.max(0, Math.min(1, v / max));
            const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
            pts.push(`${(cx + Math.cos(angle) * r * ratio).toFixed(1)},${(cy + Math.sin(angle) * r * ratio).toFixed(1)}`);
        }
        return pts.join(' ');
    }

    public hexGridPolygons(): string[] {
        const cats = this.diagTemplate.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        const n = cats.length || 6;
        const out: string[] = [];
        for (const ratio of [0.25, 0.5, 0.75, 1.0]) {
            const pts: string[] = [];
            for (let i = 0; i < n; i++) {
                const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
                pts.push(`${(cx + Math.cos(angle) * r * ratio).toFixed(1)},${(cy + Math.sin(angle) * r * ratio).toFixed(1)}`);
            }
            out.push(pts.join(' '));
        }
        return out;
    }

    public hexLabelPos(i: number): { x: number, y: number, anchor: string } {
        const cats = this.diagTemplate.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize + 22;
        const n = cats.length || 6;
        const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
        const x = cx + Math.cos(angle) * r;
        const y = cy + Math.sin(angle) * r;
        let anchor = 'middle';
        if (Math.cos(angle) > 0.3) anchor = 'start';
        else if (Math.cos(angle) < -0.3) anchor = 'end';
        return { x, y, anchor };
    }

    public async openReportEditor(a: any = null) {
        this.reportForm = this._emptyReport();
        if (a) {
            this.reportForm.program_id = a.program_id;
            this.reportForm.module_id = a.module_id;
            this.reportForm.application_id = a.application_id;
            this.reportForm.title = `${a.application_company || ''} 멘토링 보고서`;
        }
        const res = await wiz.call('get_form', { program_id: this.reportForm.program_id });
        this.reportTemplate = res.data?.template;
        this.showReportEditor = true;
        await this.service.render();
    }

    public closeReportEditor() { this.showReportEditor = false; }

    public async submitReport() {
        if (!this.reportForm.title) { this.service.alert.show({ title: '오류', message: '제목 필수' }); return; }
        const res = await wiz.call('submit_report', { data: JSON.stringify(this.reportForm) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showReportEditor = false;
        if (this.menu === 'reports') await this._loadByMenu();
        await this.service.render();
        this.service.alert.show({ title: '완료', message: '멘토링 보고서가 제출되었습니다' });
    }

    public assignmentOptions(): any[] {
        return (this.assignments || []).filter((a: any) => !!a.application_id);
    }

    public assignmentLabel(a: any): string {
        return [a?.application_company || '기업 미지정', a?.module_title || '모듈 미지정', a?.role_label || '멘토']
            .filter((x: any) => !!x).join(' · ');
    }

    public assignmentRequest(a: any): any {
        const req = a?.assignment_request || a?.extra?.assignment_request || {};
        return {
            documents: req?.documents || '',
            note: req?.note || '',
        };
    }

    public hasAssignmentRequest(a: any): boolean {
        const req = this.assignmentRequest(a);
        return !!((req.documents || '').trim() || (req.note || '').trim());
    }

    public requestDocumentLines(value: any): string[] {
        return String(value || '').split('\n').map((v: string) => v.trim()).filter((v: string) => !!v);
    }

    public assignmentSchedule(a: any): any {
        return a?.schedule || a?.extra?.schedule || {};
    }

    public scheduleSummary(a: any): string {
        const s = this.assignmentSchedule(a);
        const parts = [s.start_at || '', s.location || '', s.online_url ? '온라인' : ''].filter((v: any) => !!v);
        return parts.length > 0 ? parts.join(' · ') : '시간/장소 미정';
    }

    public openScheduleEditor(a: any) {
        this.scheduleAssignment = a;
        const s = this.assignmentSchedule(a);
        this.scheduleForm = {
            ...this._emptyScheduleForm(),
            ...JSON.parse(JSON.stringify(s || {})),
        };
        this.showScheduleEditor = true;
        this.service.render();
    }

    public closeScheduleEditor() {
        this.showScheduleEditor = false;
        this.scheduleAssignment = null;
        this.scheduleForm = this._emptyScheduleForm();
        this.service.render();
    }

    public async saveSchedule() {
        if (!this.scheduleAssignment?.id) return;
        const payload = {
            start_at: this.scheduleForm.start_at || '',
            end_at: this.scheduleForm.end_at || '',
            duration_min: Number(this.scheduleForm.duration_min) || 0,
            location: this.scheduleForm.location || '',
            online_url: this.scheduleForm.online_url || '',
            note: this.scheduleForm.note || '',
        };
        const res = await wiz.call('update_assignment_schedule', {
            assignment_id: this.scheduleAssignment.id,
            schedule: JSON.stringify(payload),
        });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '시간/장소 저장 실패' });
            return;
        }
        this.scheduleAssignment.schedule = res.data?.schedule || payload;
        const idx = (this.assignments || []).findIndex((a: any) => a.id === this.scheduleAssignment.id);
        if (idx >= 0) this.assignments[idx].schedule = this.scheduleAssignment.schedule;
        this.closeScheduleEditor();
        await this.service.render();
        this.service.alert.show({ title: '완료', message: '멘토링 시간/장소가 저장되었습니다.' });
    }

    private assignmentById(id: string): any {
        return (this.assignments || []).find((a: any) => a.id === id) || null;
    }

    private assignmentForFeedback(item: any): any {
        return (this.assignments || []).find((a: any) => {
            if (a.application_id !== item.application_id) return false;
            if (item.module_id && a.module_id !== item.module_id) return false;
            return true;
        }) || null;
    }

    public openFeedbackEditor(a: any = null, item: any = null) {
        this.feedbackForm = this._emptyFeedback();
        if (item) {
            const matched = this.assignmentForFeedback(item);
            this.feedbackForm = {
                ...this._emptyFeedback(),
                ...JSON.parse(JSON.stringify(item || {})),
                assignment_id: matched?.id || '',
                score: item.score === undefined ? null : item.score,
            };
        } else if (a) {
            this.feedbackForm.assignment_id = a.id;
            this.feedbackForm.program_id = a.program_id;
            this.feedbackForm.module_id = a.module_id;
            this.feedbackForm.application_id = a.application_id;
            this.feedbackForm.title = `${a.application_company || ''} 활동 기록`;
        } else if (this.assignmentOptions().length > 0) {
            const first = this.assignmentOptions()[0];
            this.feedbackForm.assignment_id = first.id;
            this.onFeedbackAssignmentChange(first.id);
        }
        this.showFeedbackEditor = true;
        this.service.render();
    }

    public closeFeedbackEditor() {
        this.showFeedbackEditor = false;
        this.service.render();
    }

    public onFeedbackAssignmentChange(assignmentId: string) {
        const a = this.assignmentById(assignmentId);
        if (!a) return;
        this.feedbackForm.program_id = a.program_id;
        this.feedbackForm.module_id = a.module_id;
        this.feedbackForm.application_id = a.application_id;
        if (!this.feedbackForm.title) this.feedbackForm.title = `${a.application_company || ''} 활동 기록`;
    }

    public async submitFeedback() {
        const a = this.assignmentById(this.feedbackForm.assignment_id);
        if (!a) {
            this.service.alert.show({ title: '오류', message: '기록할 배정 기업을 선택하세요.' });
            return;
        }
        if (!this.feedbackForm.content && !this.feedbackForm.title) {
            this.service.alert.show({ title: '오류', message: '제목 또는 내용을 입력하세요.' });
            return;
        }
        const payload = {
            id: this.feedbackForm.id || '',
            program_id: a.program_id,
            module_id: a.module_id,
            application_id: a.application_id,
            feedback_type: this.feedbackForm.feedback_type || 'mentor',
            title: this.feedbackForm.title || '',
            score: this.feedbackForm.score === '' ? null : this.feedbackForm.score,
            content: this.feedbackForm.content || '',
            is_visible_to_company: !!this.feedbackForm.is_visible_to_company,
        };
        const res = await wiz.call('save_feedback', { data: JSON.stringify(payload) });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' });
            return;
        }
        this.showFeedbackEditor = false;
        if (this.menu === 'records') await this._loadByMenu();
        await this.service.render();
        this.service.alert.show({ title: '완료', message: '활동 기록이 저장되었습니다' });
    }

    public async deleteFeedback(item: any) {
        if (!item?.id || !confirm('이 활동 기록을 삭제하시겠습니까?')) return;
        const res = await wiz.call('delete_feedback', { id: item.id });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' });
            return;
        }
        await this._loadByMenu();
        await this.service.render();
    }

    // ===== Documents =====
    public hasProvidedDocs(): boolean {
        return (this.documentContexts || []).some((ctx: any) => (ctx.provided || []).length > 0);
    }

    public hasRequestedDocs(): boolean {
        return (this.documentContexts || []).some((ctx: any) => (ctx.requests || []).length > 0);
    }

    public requestStatus(req: any): any {
        if (req?.submission?.status === 'submitted') return { label: '제출 완료', cls: 'bg-blue-50 text-blue-700' };
        if (req?.submission?.status === 'approved') return { label: '확인 완료', cls: 'bg-emerald-50 text-emerald-700' };
        if (req?.submission?.status === 'rejected') return { label: '반려', cls: 'bg-red-50 text-red-700' };
        return { label: '미제출', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public fieldInputType(f: any): string {
        if (f?.type === 'date') return 'date';
        if (f?.type === 'number') return 'number';
        return 'text';
    }

    public documentFileValue(f: any): any {
        if (!f?.key) return null;
        return (this.documentForm.form_data || {})[f.key] || null;
    }

    public documentFileLabel(f: any): string {
        const value = this.documentFileValue(f);
        if (!value) return '';
        if (typeof value === 'object') return value.name || value.file_name || value.url || '업로드 파일';
        return String(value);
    }

    public documentFileUrl(f: any): string {
        const value = this.documentFileValue(f);
        if (!value) return '';
        if (typeof value === 'object') return value.url || value.file_url || '';
        const text = String(value);
        if (text.indexOf('/file/download/') === 0 || text.indexOf('http://') === 0 || text.indexOf('https://') === 0) return text;
        return '';
    }

    public async uploadDocumentField(f: any) {
        if (!f?.key) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            if (!this.documentForm.form_data) this.documentForm.form_data = {};
            this.documentForm.form_data[f.key] = { name: files[0].name, url };
        } catch (e) {
            this.service.alert.show({ title: '오류', message: '파일 업로드에 실패했습니다.' });
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public removeDocumentFieldFile(f: any) {
        if (!f?.key || !this.documentForm.form_data) return;
        delete this.documentForm.form_data[f.key];
        this.service.render();
    }

    private fieldMissing(field: any, value: any): boolean {
        if (field?.type === 'checkbox') return value !== true;
        if (Array.isArray(value)) return value.length === 0;
        if (value === undefined || value === null) return true;
        return String(value).trim() === '';
    }

    public openDocumentEditor(ctx: any, req: any) {
        this.documentContext = ctx;
        this.documentRequest = req;
        this.documentForm = {
            form_data: {
                ...((req?.submission && req.submission.form_data) || {}),
            },
        };
        this.showDocumentEditor = true;
        this.service.render();
    }

    public closeDocumentEditor() {
        this.showDocumentEditor = false;
        this.documentContext = null;
        this.documentRequest = null;
        this.service.render();
    }

    public async submitDocument() {
        if (!this.documentContext || !this.documentRequest) return;
        const missing = (this.documentRequest.fields || [])
            .filter((f: any) => f.required && this.fieldMissing(f, this.documentForm.form_data?.[f.key]))
            .map((f: any) => f.label || f.key);
        if (missing.length > 0) {
            this.service.alert.show({ title: '오류', message: `필수 항목을 입력하세요: ${missing.join(', ')}` });
            return;
        }
        const payload = {
            module_id: this.documentContext.module_id,
            request_id: this.documentRequest.id,
            form_data: this.documentForm.form_data || {},
        };
        const res = await wiz.call('submit_mentor_document', { data: JSON.stringify(payload) });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '제출 실패' });
            return;
        }
        this.showDocumentEditor = false;
        await this._loadByMenu();
        await this.service.render();
        this.service.alert.show({ title: '완료', message: '서류가 제출되었습니다' });
    }
}

export default PageMentorComponent;